import VersionOverview from 'app/developer-v3/pages/versionOverview';

export default {
  routes: {
    '.': VersionOverview,
  },
};
